import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Icons } from '@bice_vida/ds-components-icons';

interface AssistedBarProps {
  name: ReactNode;
}

export const AssistedBar = ({ name }: AssistedBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 bg-color/neutral/10 p-2 justify-center items-center">
      <Icons name="person" fill="#204FCC" />

      <p className="text-gray-500 text-sm pr-1">
        <Trans t={t} i18nKey="flow.assisted_by" />
      </p>
      {typeof name === 'string' ? <span className="font-semibold">{name}</span> : name}
    </div>
  );
};
